import { render, staticRenderFns } from "./PointSingle.vue?vue&type=template&id=60d1b4ee&scoped=true&"
import script from "./PointSingle.vue?vue&type=script&lang=js&"
export * from "./PointSingle.vue?vue&type=script&lang=js&"
import style0 from "./PointSingle.vue?vue&type=style&index=0&id=60d1b4ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d1b4ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VExpandTransition,VTimelineItem})
